import { render, staticRenderFns } from "./gonetwork0.vue?vue&type=template&id=155a5e48&scoped=true&"
import script from "./gonetwork0.vue?vue&type=script&lang=js&"
export * from "./gonetwork0.vue?vue&type=script&lang=js&"
import style0 from "./gonetwork0.vue?vue&type=style&index=0&id=155a5e48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155a5e48",
  null
  
)

export default component.exports